import { useEffect, useState } from 'react'

import Collapse from '@mui/material/Collapse'

import { StyledAlert } from '../../../theme/components/StyledAlert'
import type { PlanningPreview } from '../types/PlanningPreview'

type Props = {
  planningPreview?: PlanningPreview
}

export const PlanningPreviewInfo = ({ planningPreview }: Props) => {
  // Keeps the last result, so the alert keeps its content while collapsing
  const [shown, setShown] = useState(planningPreview)
  useEffect(() => {
    if (planningPreview) {
      setShown(planningPreview)
    }
  }, [planningPreview])

  const eindeWeek = shown?.eindUitvoeringWeek
  const totaleDoorlooptijdWeken = shown?.totaleDoorlooptijdWeken ?? 0
  const geblokkeerdeWeken = shown?.geblokkeerdeWeken ?? []
  const werkbareWeken = totaleDoorlooptijdWeken - geblokkeerdeWeken.length

  return (
    <Collapse in={Boolean(planningPreview)} unmountOnExit>
      <StyledAlert severity="info">
        Geplande eind uitvoeringsweek: {eindeWeek}
      </StyledAlert>

      <Collapse in={geblokkeerdeWeken.length > 0} unmountOnExit>
        <StyledAlert severity="warning" title="Let op!">
          {`Door geblokkeerde weken (${geblokkeerdeWeken.join(', ')}) eindigt de uitvoering in ${eindeWeek}. Totale doorlooptijd: ${totaleDoorlooptijdWeken} weken (${werkbareWeken} werkbare weken + ${geblokkeerdeWeken.length} geblokkeerd).`}
        </StyledAlert>
      </Collapse>
    </Collapse>
  )
}
